import { render } from "./dateCompo.vue?vue&type=template&id=60746084"
import script from "./dateCompo.vue?vue&type=script&lang=js"
export * from "./dateCompo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__